import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyCL5-ut2nqFwU34R-h5cuwnvvjkKNBHVYw",
  authDomain: "sistema-delta-rio.firebaseapp.com",
  projectId: "sistema-delta-rio",
  storageBucket: "sistema-delta-rio.appspot.com",
  messagingSenderId: "245985418935",
  appId: "1:245985418935:web:fc80611d6fc1cebb067732"
};
  // Initialize Firebase
  export default firebase.initializeApp(firebaseConfig);
  //export default firebase.analytics();